import { render, staticRenderFns } from "./AboutUsClient.vue?vue&type=template&id=98634f8c"
import script from "./AboutUsClient.vue?vue&type=script&lang=js"
export * from "./AboutUsClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports